import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { HeadWeightNumberAftDto } from '../../api/models/HeadWeightNumberAftDto';

export type TABLE_TYPE = Table<HeadWeightNumberAftDto>;

export const TABLE = 'headWeightNumberAft';
const SCHEMA = 'headWeightNumberAftId';

class HeadWeightNumberAftDatabase implements DataRepository<HeadWeightNumberAftDto> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<HeadWeightNumberAftDto | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: HeadWeightNumberAftDto, key: Key): Promise<HeadWeightNumberAftDto> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: HeadWeightNumberAftDto[]): Promise<HeadWeightNumberAftDto[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<HeadWeightNumberAftDto[]> {
    return this.db[TABLE].toArray();
  }
}

export const HeadWeightNumberAftDB = new HeadWeightNumberAftDatabase(db);
